export default __webpack_public_path__ + "static/media/a021-viewmore.5d763d2c.png";